import React from 'react';
import Moment from 'react-moment';
import clsx from 'clsx';
import styles from '../activity.module.css';

export default function ActivityItem(props) {
	const { activity } = props;

	const activityDate = activity?.logged || activity?.requestedAt;

	const lines = activity?.description.split('\n');

	return (
		<div
			className={[
				styles.activityRoot,
				activity.last && styles.activityLast,
			].join(' ')}>
			<div
				className={clsx(
					styles.activityLine,
					activity.index === 0
						? activity.only
							? styles.activityOnlyLine
							: styles.activityFirstLine
						: activity.last
						? styles.activityLastLine
						: null
				)}
			/>
			<div className={styles.activityCircle} />
			<div className={styles.activityContent}>
				{activityDate ? (
					<div className={styles.activityDate}>
						<Moment format='MMMM DD, YYYY H:mma'>{activityDate}</Moment>
					</div>
				) : null}
				<div className={styles.activityLabel}>
					{lines.map((line, index) => (
						<React.Fragment key={index}>
							{line} {index < lines.length - 1 && <br />}
						</React.Fragment>
					))}
				</div>
				{activity.subHeader ? (
					<React.Fragment>
						{activity.subHeader.type === 'Requested' ||
						(activity.subHeader.type === 'Expires' &&
							activity.subHeader.expired) ? (
							<div
								style={{ color: 'red', display: 'flex', flexDirection: 'row' }}>
								<p style={{ paddingRight: '5px' }}>
									{activity.subHeader.type === 'Expires'
										? 'Expired on:'
										: 'Expires on:'}
								</p>
								<Moment format='MMMM DD, YYYY H:mma'>
									{activity.subHeader.date}
								</Moment>
							</div>
						) : (
							<>
								{activity.subHeader.type} on{' '}
								<Moment format='MMMM DD, YYYY H:mma'>
									{activity.subHeader?.date}
								</Moment>
							</>
						)}
					</React.Fragment>
				) : null}
			</div>
		</div>
	);
}
